/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ActionsToTakeFromJSON, ActionsToTakeToJSON, } from './ActionsToTake';
import { PaymentProcessStatusPaymentsInnerFromJSON, PaymentProcessStatusPaymentsInnerToJSON, } from './PaymentProcessStatusPaymentsInner';
import { PaymentProcessStatusErrorTranslationsInnerFromJSON, PaymentProcessStatusErrorTranslationsInnerToJSON, } from './PaymentProcessStatusErrorTranslationsInner';
import { PaymentProcessStatusErrorsInnerFromJSON, PaymentProcessStatusErrorsInnerToJSON, } from './PaymentProcessStatusErrorsInner';
/**
 * @export
 */
export const PaymentProcessStatusFraudStatusEnum = {
    NoResult: 'no_result',
    Approved: 'approved',
    Declined: 'declined',
    NotDone: 'not_done',
    _3ds: '3ds',
    Authorize: 'authorize'
};
/**
 * @export
 */
export const PaymentProcessStatusStatusEnum = {
    Unpaid: 'unpaid',
    Processing: 'processing',
    Paid: 'paid',
    Finalizing: 'finalizing',
    Finalized: 'finalized',
    Canceling: 'canceling',
    Cancelled: 'cancelled',
    Failed: 'failed'
};
/**
 * Check if a given object implements the PaymentProcessStatus interface.
 */
export function instanceOfPaymentProcessStatus(value) {
    if (!('actionsToTake' in value) || value['actionsToTake'] === undefined)
        return false;
    if (!('errorTranslations' in value) || value['errorTranslations'] === undefined)
        return false;
    if (!('errors' in value) || value['errors'] === undefined)
        return false;
    if (!('fraudStatus' in value) || value['fraudStatus'] === undefined)
        return false;
    if (!('payments' in value) || value['payments'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function PaymentProcessStatusFromJSON(json) {
    return PaymentProcessStatusFromJSONTyped(json, false);
}
export function PaymentProcessStatusFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'actionsToTake': (json['actions_to_take'].map(ActionsToTakeFromJSON)),
        'errorTranslations': (json['error_translations'].map(PaymentProcessStatusErrorTranslationsInnerFromJSON)),
        'errors': (json['errors'].map(PaymentProcessStatusErrorsInnerFromJSON)),
        'fraudStatus': json['fraud_status'],
        'orderId': json['order_id'] == null ? undefined : json['order_id'],
        'payments': (json['payments'].map(PaymentProcessStatusPaymentsInnerFromJSON)),
        'status': json['status'],
    };
}
export function PaymentProcessStatusToJSON(json) {
    return PaymentProcessStatusToJSONTyped(json, false);
}
export function PaymentProcessStatusToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'actions_to_take': (value['actionsToTake'].map(ActionsToTakeToJSON)),
        'error_translations': (value['errorTranslations'].map(PaymentProcessStatusErrorTranslationsInnerToJSON)),
        'errors': (value['errors'].map(PaymentProcessStatusErrorsInnerToJSON)),
        'fraud_status': value['fraudStatus'],
        'order_id': value['orderId'],
        'payments': (value['payments'].map(PaymentProcessStatusPaymentsInnerToJSON)),
        'status': value['status'],
    };
}
